export default {
  env: 'dev',
  DefaultChainId: '56',
  Contract: {
    "Cell": "0x8aA9B157C827C410CcBc4D5242BD3c0641f9B1b3",
    "Proxy": "0x8A7A3e37089C8E6Dff3D37e2912368E743259496",
    "SCT": "0xa4B068aD60766E20283C0424C1F543E45100cFE3",
    "USDT": "0xb8e4d503f9619E2B2f4654ad6C3aF05Da9cc0C8e",
    "BUSD": "0x4E202209C6419CF78f7c19BD8D5BB88a55aDa9BE",
    "ETH": "0xB108e6B00a36562F3B60eAB91032505862B1F748",
    "Oracle": "0xCa902dc22a54D083cDE3c8FeaA6ce18bacE59D4d",
    "Nucleus": "0x2a990cdaFdE3Cc433D0C5eb2e8A4169f6cD8EB8b"
  },
  ContractMainnet: {
    "Cell": "0x8aA9B157C827C410CcBc4D5242BD3c0641f9B1b3",
    "Proxy": "0x8A7A3e37089C8E6Dff3D37e2912368E743259496",
    "SCT": "0x405e7454e71aefe8897438adc08e3f3e6d49dfc1", 
    "USDT": "0x55d398326f99059ff775485246999027b3197955",
    "BUSD": "0xe9e7cea3dedca5984780bafc599bd69add087d56",
    "ETH": "0x2170ed0880ac9a755fd29b2688956bd959f933f8",
    "Oracle": "0x3614A30000208d532418EA95B0eC3329987B8587",
    "Nucleus": "0xBad8455C09f9402432827872177cDf185BbDfc18" 
  },
  Swap: {
    fromChainId: '97',
    fromChainIdMainmet: '56'
  },
  ChainList: [
    {
      chainId: '97',
      chainIdHex: '0x61',
      name: 'BSC Testnet',
      logo: 'bsc.svg',
      config: {
        chainId: '0x61',
        chainName: 'BSC Testnet',
        nativeCurrency: {
          name: 'BNB',
          symbol: 'BNB',
          decimals: 18,
        },
        rpcUrls: ['https://data-seed-prebsc-1-s3.binance.org:8545/'],
        blockExplorerUrls: ['https://testnet.bscscan.com/'],
      },
    },
    {
      chainId: '56',
      chainIdHex: '0x38',
      name: 'BSC Mainnet',
      logo: 'bsc.svg',
      config: {
        chainId: '0x38',
        chainName: 'BSC Mainnet',
        nativeCurrency: {
          name: 'BNB',
          symbol: 'BNB',
          decimals: 18,
        },
        rpcUrls: ['https://bsc-dataseed.binance.org/'],
        blockExplorerUrls: ['https://bscscan.com/'],
      },
    },
  ],
}
